import { useEffect, useState } from 'react';
import MainTitle from '../../../components/template/MainTitle'
import NewInfoFormat from '../../../components/template/NewInfoFormat'
import NewInfoSelector from '../../../components/template/NewInfoSelector'
import ButtonWrap from '../../../components/template/ButtonWrap'
import { classNames } from '../../../components/utils/Utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { Link } from 'react-router-dom'
import api from '../../../components/utils/api';
import SubTitle from '../../../components/template/SubTitle';

const LoadExistingData = ({ title, onClick, dataSource }) => {
    const [dbOptions, setDbOptions] = useState([])
    const [expOptions, setExpOptions] = useState([])
    const [modelOptions, setModelOptions] = useState([])
    const [dataOptions, setDataOptions] = useState([])

    const [dbVersion, setDbVersion] = useState(undefined)
    const [expVersion, setExpVersion] = useState(undefined)
    const [modelType, setModelType] = useState(undefined)
    const [data, setData] = useState(undefined)

    const [mergeRules, setMergeRules] = useState([])
    const [generalModelId, setGeneralModelId] = useState(undefined)
    const [selectedMergeRuleId, setSelectedMergeRuleId] = useState()

    useEffect(() => {
        const fetchDbOptions = async () => {
            try {
                const response = await api.get('/api/model-selection/dbs')
                setDbOptions(response.data.dbs)
            } catch (err) {
                console.error(err)
            }
        }
        fetchDbOptions()
    }, [])

    useEffect(() => {
        const fetchExpOptions = async () => {
            try {
                const response = await api.get(`/api/model-selection/experiments?db_ver=${dbVersion.value}`)
                setExpOptions(response.data.experiments)
            } catch (err) {
                console.error(err)
            }
        }

        if (dbVersion) {
            setExpVersion(undefined)
            setExpOptions([])
            fetchExpOptions()
        }
    }, [dbVersion])

    useEffect(() => {
        const fetchModelOptions = async () => {
            try {
                const response = await api.get(`/api/model-selection/model-types?db_ver=${dbVersion.value}&exp_ver=${expVersion.value}`)
                setModelOptions(response.data.model_types)
            } catch (err) {
                console.error(err)
            }
        }

        if (dbVersion && expVersion) {
            setModelType(undefined)
            setModelOptions([])
            fetchModelOptions()
        }
    }, [dbVersion, expVersion])

    useEffect(() => {
        const fetchGeneralModelId = async () => {
            try {
                const response = await api.get(`/api/general-models/resolve?model_name=${dbVersion.value}_${expVersion.value}_${modelType.value}`)
                setGeneralModelId(response.data.id)
            } catch (err) {
                console.error(err)
            }
        }

        if (dbVersion && expVersion && modelType) {
            fetchGeneralModelId()
        }
    }, [dbVersion, expVersion, modelType])

    // TODO: replace this with the new API
    useEffect(() => {
        if (selectedMergeRuleId && dataSource !== "mergerule") {
            setData(undefined)
            api.get(`/api/merge-rules/${selectedMergeRuleId}/${dataSource}`)
                .then(res => setDataOptions(res.data[dataSource].map(e => ({ label: e.name, value: e.id }))))
                .catch(err => console.error(err))
        }
    }, [modelType, selectedMergeRuleId, dataSource])

    const onClickSearch = () => {
        if (generalModelId) {
            const fetchMergeRules = async () => {
                const response = await api.get(`/api/general-models/${generalModelId}/merge-rules`)
                setMergeRules(response.data.merge_rules)
            }
            fetchMergeRules()
        }
    }

    return (
        <div>
            <MainTitle title={title} />
            <div className='grid grid-cols-3 gap-1'>
                {[
                    {
                        label: "Database Version", contents: <NewInfoSelector
                            value={dbVersion}
                            setValue={setDbVersion}
                            options={dbOptions.map(e => ({ label: e, value: e }))}
                            category=""
                            noOptionsMessage="Loading..."
                        />, description: <></>
                    },
                    {
                        label: "Experiment Number", contents: <NewInfoSelector
                            value={expVersion}
                            setValue={setExpVersion}
                            options={expOptions.map(e => ({ label: e, value: e }))}
                            category=""
                            noOptionsMessage="Please select the database version first"
                        />, description: <></>
                    },
                    {
                        label: "Model Type", contents: <NewInfoSelector
                            value={modelType}
                            setValue={setModelType}
                            options={modelOptions.map(e => ({ label: e, value: e }))}
                            category=""
                            noOptionsMessage="Please select the database version and experiment number first"
                        />, description: <></>
                    },
                ].map((e, i) => <NewInfoFormat label={e.label} contents={e.contents} description={e.description} key={i} />)}
            </div>
            <div className='text-right'>
                <ButtonWrap contents="Search" onClick={onClickSearch} isDisabled={!generalModelId} />
            </div>
            {mergeRules.length !== 0 && <div>
                <SubTitle title={"Merge rule"} />
                <ul className='my-2 border rounded p-4 md:grid md:grid-cols-2 text-left'>
                    {mergeRules.map((e, i) => <li
                        key={i}
                        className={classNames("flex px-2 py-1 cursor-pointer", e.id === selectedMergeRuleId ? "bg-violet-100 text-violet-500 border-violet-500" : "")}
                    >
                        <p onClick={() => setSelectedMergeRuleId(e.id)}>{e.name}</p>
                        <Link
                            target='_blank' rel="noopener noreferrer"
                            to={`/merge-rule/${e.id}`}
                            className="mx-1"
                        ><FontAwesomeIcon icon={faCircleQuestion} size='sm' color='gray' /></Link>
                    </li>)}
                </ul>
                {
                    dataSource === "mergerule" ?
                        <div className='text-right'>
                            <ButtonWrap contents={"Load"} onClick={() => onClick(selectedMergeRuleId)} isDisabled={!selectedMergeRuleId} />
                        </div> :
                        <div>
                            {selectedMergeRuleId &&
                                <div>
                                    <NewInfoFormat
                                        label={dataSource.charAt(0).toUpperCase() + dataSource.slice(1).toLowerCase()}
                                        contents={<NewInfoSelector
                                            value={data}
                                            setValue={setData}
                                            options={dataOptions}
                                            category=""
                                            noOptionsMessage="Loading..."
                                        />}
                                        description={<></>}
                                    />
                                    <div className='text-right'>
                                        <ButtonWrap contents={"Load"} onClick={() => onClick(selectedMergeRuleId, data.value)} isDisabled={!(selectedMergeRuleId && data)} />
                                    </div>
                                </div>}
                        </div>
                }
            </div>}
        </div >
    )
}

export default LoadExistingData